export default "__VITE_ASSET__1YVQeWiW__"